var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { HexColorPicker } from "react-colorful";
import { useState, useRef, useEffect } from "react";
import TextField from "../../Atoms/Inputs/TextField";
import PaletteIcon from "@mui/icons-material/Palette";
import Popover from "@mui/material/Popover";
var ColorPicker = function (_a) {
    var onChange = _a.onChange, value = _a.value, textFieldProps = _a.textFieldProps;
    var _b = __read(useState(""), 2), hex = _b[0], setHex = _b[1];
    var _c = __read(useState(false), 2), showPopover = _c[0], setShowPopover = _c[1];
    var _d = __read(useState(null), 2), anchorEl = _d[0], setAnchorEl = _d[1];
    var anchorRef = useRef(null);
    var handleClick = function () {
        if (anchorRef.current) {
            setAnchorEl(anchorRef.current);
            setShowPopover(true);
        }
    };
    var handleClose = function () {
        setAnchorEl(null);
        setShowPopover(false);
    };
    useEffect(function () {
        setAnchorEl(anchorRef.current || null);
    }, [anchorRef]);
    var updateColor = function (color) {
        if (!color.includes("NaN")) {
            setHex(color);
            if (onChange) {
                onChange(color);
            }
        }
    };
    var handleTextInputChange = function (e) {
        var color = e.target.value;
        updateColor("#".concat(color.replaceAll("#", "")));
    };
    var popoverSxProps = {
        ".w-color-saturation": {
            borderRadius: 0,
        },
        // hide opacity slider
        ".w-color-alpha:not(.w-color-hue)": {
            display: "none",
        },
    };
    return (_jsxs(Stack, __assign({ ref: anchorRef }, { children: [_jsx(TextField, __assign({ endAdornment: (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.endAdornment) || _jsx(PaletteIcon, {}), endAdornmentClick: handleClick, onChange: handleTextInputChange, colorSwatch: true, value: value || hex }, textFieldProps)), _jsx(Popover, __assign({ sx: popoverSxProps, open: Boolean(anchorEl) && showPopover, PaperProps: {
                    sx: { overflow: "visible" },
                }, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                }, "data-testid": "color-picker-popover" }, { children: _jsx(Stack, __assign({ sx: { padding: "10px" } }, { children: _jsx(HexColorPicker, { color: value || hex, onChange: updateColor, "data-testid": "color-picker-palette" }) })) }))] })));
};
export default ColorPicker;
